export type { ApprovalState } from '@zag/approvals/models';
